import React from "react";
import { useColetaPrevia } from "@hooks";
import { TipoPendenciaColetaPrevia } from "@services";
import CapturaFoto from "../captura-foto";

const CapturaSelfie = ({
  idSolicitacao,
  cpf,
  setScreenToShow,
  telaSeguinte = "captura-documento",
}) => {
  const { enviar } = useColetaPrevia(idSolicitacao, cpf);

  const handleConfirmar = async (foto) => {
    await enviar(TipoPendenciaColetaPrevia.Selfie, foto);
    setScreenToShow(telaSeguinte);
  };

  return (
    <CapturaFoto
      tipoGuia="selfie"
      instrucao="Posicione seu rosto dentro da área da câmera e tire uma foto."
      altTextoPreview="Prévia da selfie"
      onConfirmar={handleConfirmar}
    />
  );
};

export default CapturaSelfie;
